module.exports = __webpack_public_path__ + "img/Zaki Manian.ae859521.jpg";